import CreateCourse from './container.js'
export default CreateCourse
